import React from "react";
import LoginUser from "./LoginUser/LoginUser";

const Login = () => {
  return (
    <>
      <div align={"center"}>
        <LoginUser />
      </div>
    </>
  );
};

export default Login;
